module.exports = __webpack_public_path__ + "img/tennis-dark.8b131f0d.svg";